<template>
  <section>
    <Banner value="Compra de uniformes"/>
    <hr style="border:5px solid #DDD">

    <section style="background:#DDD;">
      <v-container grid-list-xl>
        <v-layout row wrap my-2>
          <v-flex xs12>
            <p
              class="lead"
            >O uniforme é a forma mais prática de facilitar o controle de vestimenta pela escola e representa para os pais uma economia com as roupas dos filhos. Sua principal vantagem é oferecer segurança para rápida identificação daqueles que são estudantes da Escola Engenho dentro e fora das dependências da escola.</p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section style="background:none; padding:70px 0">
      <h1 style="text-align:center; font-size:25px; line-height:1.1em;">
        <span style="font-size:45px;">Uniformes à venda</span>
        <br>na loja Babana Bacana no Campeche
      </h1>
      <br>
      <v-container grid-list-xl>
        <v-layout row wrap>
          <v-flex md6>
            <ul>
              <li style="margin-top:0; padding-top:0;">
                Loja
                <ul>
                  <li class="lead">
                    Banana Bacana
                    <br>
                    <small>Uniformes Escolares e Moda Infantil</small>
                  </li>
                </ul>
              </li>
              <li>
                Endereço
                <ul>
                  <li>
                    Avenida Pequeno Príncipe, 1890
                    <br>Condomínio Comercial Campeche II, sala 3
                    <br>Campeche - Florianópolis - SC
                    <br>
                    <small>Uniformes Escolares e Moda Infantil</small>
                  </li>
                </ul>
              </li>
              <li>
                Horário de atendimento
                <ul>
                  <li>
                    <b>Segunda a sexta:</b><br>
                    manhã: 10 h às 12 h<br>
                    tarde: 14 h às 18 h
                  </li>
                  <li>
                    <b>Sábado:</b>
                    <br>9h30min às 13h30min
                    <small>(No sábado não fecha para almoço)</small>
                  </li>
                </ul>
              </li>
              <li>
                Telefone
                <ul>
                  <li>
                    {{fone}}
                    <v-btn :href="'tel:'+fone" round color="success">
                      <v-icon style="margin-right:5px">phone</v-icon>Ligar
                    </v-btn>
                    <v-btn :href="foneWhats" round color="success">
                      <i class="fa-2x fab fa-whatsapp" style="margin-right:5px"></i> WhatsApp
                    </v-btn>
                  </li>
                  <!-- <li>
                    {{fone2}}
                    <v-btn :href="'tel:'+fone2" round color="success">
                      <v-icon style="margin-right:5px">phone</v-icon>Ligar
                    </v-btn>
                    <v-btn :href="fone2Whats" round color="success">
                      <i class="fa-2x fab fa-whatsapp" style="margin-right:5px"></i> WhatsApp
                    </v-btn>
                  </li> -->
                </ul>
              </li>
              <li>
                Email
                <ul>
                  <li>
                    {{email}}
                    <v-btn :href="'mailto:'+email" round color="default">
                      <v-icon style="margin-right:5px">email</v-icon>email
                    </v-btn>
                  </li>
                </ul>
              </li>
            </ul>
            <br>
            <p>*Como são feitas alterações no estoque diariamente, pode não haver disponibilidade de alguns itens.</p>
          </v-flex>
          <v-flex md6>
            <img src="/images/uniforme1.jpg" style="width:100%;">
            <br>
            <br>
            <h4>Mapa da Loja Banana Bacana</h4>
            <img src="/images/banana-bacana-uniformes-mapa.jpg" style="width:100%;">
            <!-- <h3 style="text-align:center !important; margin-top:20px;">Navegue pelo Google Maps:</h3> -->
            <v-layout>
              <v-flex xs12>
                <h4>Navegue pelo Google Maps até a loja Banana Bacana</h4>
                <v-btn :href="rota" large round block color="primary" dark>
                  <v-icon style="margin-right:3px;">directions</v-icon>Rotas
                </v-btn>
                <p
                  style="font-size:0.8em; text-align:center !important"
                >Clique para ir até a loja Banana Bacana Uniformes Escolares e Moda Infantil no Campeche</p>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </section>
</template>

<script>
import Banner from "../../components/Banner";

export default {
  data: () => ({
    rota:
      "https://www.google.com/maps/place/Av.+Pequeno+Pr%C3%ADncipe,+1890+-+Campeche+Leste,+Florian%C3%B3polis+-+SC,+88063-245/@-27.682191,-48.4947549,922m/data=!3m1!1e3!4m5!3m4!1s0x95273b6914f0e8d3:0xe86924dee062b26!8m2!3d-27.6821958!4d-48.4925662",
    fone: "(48) 9 8805-8518",
    foneWhats:
      "https://wa.me/5548988058518?text=Ol%C3%A1!%20Cheguei%20aqui%20atrav%C3%A9s%20do%20site%20da%20Escola%20Engenho.",
    fone2: "(48) 9 9630-0608",
    fone2Whats:
      "https://wa.me/5548996300608?text=Ol%C3%A1!%20Cheguei%20aqui%20atrav%C3%A9s%20do%20site%20da%20Escola%20Engenho.",
    email: "banana.bacana@yahoo.com.br"
  }),
  components: {
    Banner
  }
};
</script>

<style lang="scss" scoped>
h4 {
  text-align: center !important;
}
p {
  text-align: justify !important;
}
ul {
  padding: 0;
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  li {
    color: white;
    background: #afafaf;
    margin: 10px 0 0 0;
    padding: 5px;
    text-transform: uppercase;
    ul {
      li {
        text-transform: none;
        color: black;
        background: white;
        margin: 0;
        border-top: none;
      }
    }
  }
}
</style>

